<div
*ngIf="!unmount"
class="cookie-message"
[ngClass]="shouldShow ? 'cookie-hidded' : 'cookie-showed'"
>
  <div class="container container-cookies">
    <div class="row">

      <div class="col-md-6 col-lg-9">
        {{message}}
      </div>

      <div class="col-12 col-lg-3 btn-container">
        <button type="button" class="btn btn--primary px-5 js-historial btn-cookie" (click)="acceptCookies()">
          Aceptar
        </button>
      </div>

    </div>
  </div>
</div>
